import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {kanPartnersService} from "../../../../services/services/partners";
import {Partner} from "../../../../../classes/partner";
import {StateService} from "@uirouter/angular";
// import {kanPartnerDialog} from "../../../dialogs/partner-dialog/component";
import {MatDialog} from "@angular/material";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {kanPartnerDialog} from "../../../dialogs/partner-dialog/component";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-partner-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanPartnerListItem {
    @Input() partner: Partner;
    @Input() searchText: string;
    @Output() refresh: EventEmitter<any> = new EventEmitter();
    public toggled: boolean = false;

    constructor(private stateService: StateService,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private partnerService: kanPartnersService) {
    }

    ngOnInit(): void {
    }

    get role(): string {
        return this.authService.role;
    }

    public toggle() {
        this.toggled = !this.toggled;
    }

    public goToPartnerDetail(event: any) {
        this.stateService.go('app.admin.partner', {id: this.partner.id});
    }

    public editPartnerDialog(event: any) {
        let dialogRef = this.dialog.open(kanPartnerDialog, {
            data: {
                partner: this.partner
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.refresh.emit();
            }
        });
    }

    public removePartner(event: any) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'remove') {
                this.partnerService.removePartner(this.partner)
                    .then((data) => {
                        this.refresh.emit();
                    });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/partner/list-item/component.ts